import { restApiService } from '@tableau/vizportalclient-common-components';
import { LabelContentItem, RestLabelResponse } from './LabelTypes';
import { getLabels } from './Labels';



export type UseLabelsParams<T> = {
  readonly existing?: Partial<T>;
  readonly transform: (response: RestLabelResponse) => T; // transform a label to a Certification (no elevated) or a Warning (severe)
}

export interface UseLabelsPropsBase {
  readonly contentItem: LabelContentItem;
}

export interface DialogStateBase {
  readonly type: string;
}

export function makeFetchInitialStateForLabels<P extends UseLabelsPropsBase, S extends DialogStateBase>(params: {
  readonly category: 'warning' | 'certification' | 'sensitivity';
  readonly siteLuid: string;
  transform: (t: RestLabelResponse) => S;
}): undefined | ((bodyProps: P, dialogState: S) => Promise<S>) {

  const { transform, category, siteLuid } = params;

  const {makeJsonRestApiRequest} = restApiService({siteLuid});
  return async (bodyProps: P, dialogState: S) => {
    try {
      const { contentItem } = bodyProps;
      const result = await getLabels<S>({ transform, category, contentItems: [contentItem], makeJsonRestApiRequest });
      const labels = result.get({ contentId: contentItem.contentId, contentType: contentItem.contentType.toLowerCase() })?.filter((label) => {
        return label.type !== 'EXTRACT_REFRESH_FAILURE' && label.type !== 'FLOW_RUN_FAILURE'
      });

      if (!labels) {
        return dialogState;
      }

      const first = labels[0];
      if (!first) {
        return dialogState;
      }

      return first;
    } catch {
      return dialogState;
    }
  };
}
